import { fetchWithTrace } from '../fetchWithTrace';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';


export async function generateMusicFromPrompt(prompt) {
    return null;
}

export async function generateMusicFromPromptX(prompt) {
    const { data } = await fetchWithTrace(`${API_URL}/api/music/generate`, {
        method: 'POST',
        credentials: 'include',
        body: { prompt }
    });
    return data.url;
}
